module.exports = __webpack_public_path__ + "img/shangye_wentizhongxin_suoluetu.1eba081d.png";